import jwtDecode from 'jwt-decode';

const getTokenSubject = token => {
  try {
    return jwtDecode(token).sub || null;
  } catch {
    return null;
  }
};

/**
 * Returns credentials rotated by another tab only when they belong to the
 * same user as the refresh token whose rotation failed.
 *
 * @param {string|null} failedRefreshToken
 * @param {string|null} currentAccessToken
 * @param {string|null} currentRefreshToken
 * @returns {{access: string, refresh: string}|null}
 */
const getReplacementTokensForSameUser = (failedRefreshToken, currentAccessToken, currentRefreshToken) => {
  if (
    !failedRefreshToken ||
    !currentAccessToken ||
    !currentRefreshToken ||
    currentRefreshToken === failedRefreshToken
  ) {
    return null;
  }

  const failedTokenSubject = getTokenSubject(failedRefreshToken);
  const currentAccessTokenSubject = getTokenSubject(currentAccessToken);
  const currentTokenSubject = getTokenSubject(currentRefreshToken);

  if (
    !failedTokenSubject ||
    failedTokenSubject !== currentAccessTokenSubject ||
    failedTokenSubject !== currentTokenSubject
  ) {
    return null;
  }

  return {
    access: currentAccessToken,
    refresh: currentRefreshToken
  };
};

export { getReplacementTokensForSameUser };
